import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-update-app-dialog',
  templateUrl: './update-app-dialog.component.html',
  styleUrls: ['./update-app-dialog.component.scss'],
})
export class UpdateAppDialogComponent implements OnInit {
  constructor(
    private updateAppDialogRef: MatDialogRef<UpdateAppDialogComponent>,
    private utilityService: UtilityService
  ) {}

  ngOnInit() {
    this.updateAppDialogRef.addPanelClass('update-app-dialog-v14');
  }
}
